import { socialService } from '@watchlist/shared';

const TTL_MS = 60_000;
const cache = new Map<string, { value: number; expires: number }>();
const inflight = new Map<string, Promise<number>>();

/** Drop cached like totals so the next read hits Firestore (e.g. after like/unlike). */
export function invalidateWatchlistLikeCountCache(watchlistId?: string): void {
  if (watchlistId) {
    cache.delete(watchlistId);
    return;
  }
  cache.clear();
}

/**
 * Count of documents in watchlistLikes for this list (source of truth vs denormalized followerCount).
 * Deduplicates concurrent requests and TTL-caches per list id.
 */
export async function resolveWatchlistLikeCount(watchlistId: string): Promise<number> {
  const now = Date.now();
  const hit = cache.get(watchlistId);
  if (hit && hit.expires > now) {
    return hit.value;
  }

  let pending = inflight.get(watchlistId);
  if (!pending) {
    pending = socialService
      .getWatchlistLikeCount(watchlistId)
      .then((n) => {
        cache.set(watchlistId, { value: n, expires: Date.now() + TTL_MS });
        inflight.delete(watchlistId);
        return n;
      })
      .catch((err) => {
        inflight.delete(watchlistId);
        throw err;
      });
    inflight.set(watchlistId, pending);
  }

  return pending;
}
